import { PeriodType } from '@/common/Graph/types';
import { PortfolioPeriodType } from "@/lib/TradingAccount/types";
import { useQuery } from '@tanstack/react-query';
import { GraphDataResponse } from './../common/Graph/types';
import useCurrentUser from './useCurrentUser';

export default function useGraphData(queryKeyPrefix: string, periodType: PeriodType | PortfolioPeriodType, fetchData: (
    activePeriodType: PeriodType | PortfolioPeriodType
) => Promise<GraphDataResponse>, symbol?: string) {
    const { data: user } = useCurrentUser();

    const queryKey = [queryKeyPrefix];

    if (symbol) {
        queryKey.push(symbol);
    }

    queryKey.push(periodType);

    const query = useQuery({
        queryKey,
        queryFn: async () => fetchData(periodType),
        staleTime: 1500,
        enabled: !!periodType && !!user,
    });
    
    return query;
}